import React from 'react'
import SecretaryProfile from 'presentation/secretary/pages/Profile'

export default function makeSecretaryProfile() {
  return <SecretaryProfile />
}
